import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { CustomerModel } from '../models/customer.model';
import { LetterModel } from '../models/letter.model';
import { CustomerService } from './customer.service';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class LetterService {

    public openPanel: boolean = false;
    public letter:LetterModel;
    public state: boolean = false;
    public isSend: boolean = false;
    public error:boolean = false;

    constructor(public apiService: ApiService, private customerService:CustomerService) {

    }

    open(customer:CustomerModel){
        this.error = false;
        this.state = false;
        this.isSend = false;
        this.letter = new LetterModel(this);
        this.letter.line1 = customer.firstName + ' ' + customer.lastName;
        this.letter.line2 = customer.adressName;
        this.letter.line3 = customer.adressCode + ' ' + customer.adressCity;
        this.letter.line4 = customer.adressCountry;
        this.letter.customer = customer;
        this.openPanel = true;
    }

    send(letter:LetterModel){
        this.state = true;
        this.error = false;

        let headersCustom: Headers     = new Headers;
        let optionsCustom: RequestOptions;
        let formData:FormData = new FormData();

        formData.append('clientPrivateId', letter.customer.privateId);
        formData.append('line1', letter.line1);
        formData.append('line2', letter.line2);
        formData.append('line3', letter.line3);
        formData.append('line4', letter.line4);
        if (letter.speed)
            formData.append('categorie', 'A');
        else
            formData.append('categorie', 'B');
        formData.append('file', letter.file, letter.file.name);
        optionsCustom = new RequestOptions({
            headers: headersCustom
        });

        this.apiService.postWithFile('letter', formData, optionsCustom).subscribe((_res)=> {
            this.state = false;
            this.isSend = true;
            setTimeout(() => {
                this.openPanel = false;
            }, 1000);

            if (this.customerService.activities.privateId == letter.customer.privateId) {
                let newData = {
                    _id: '',
                    clientPrivateId: letter.customer.privateId,
                    created: new Date().toDateString(),
                    // idPdf: _res.data.idPdf,
                    line1: letter.line1,
                    line2: letter.line2,
                    line3: letter.line3,
                    line4: letter.line4,
                    state: '',
                    type: 'paper',
                    from: {
                        where: 'nowhere'
                    }
                };

                this.customerService.activities.data.unshift(newData);
            }
        }, (_err)=> {
            this.apiService.error(_err);
            this.state = false;
            this.error = true;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/letter.service.ts